import { render, staticRenderFns } from "./chooseaccount.vue?vue&type=template&id=f0965f02&scoped=true"
import script from "./chooseaccount.vue?vue&type=script&lang=js"
export * from "./chooseaccount.vue?vue&type=script&lang=js"
import style0 from "./chooseaccount.vue?vue&type=style&index=0&id=f0965f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0965f02",
  null
  
)

export default component.exports